/*eslint-disable no-script-url*/
/*global gtag*/
import React, { Component } from 'react';
import * as Common from '../components/Common';
import * as moment from 'moment';
import 'moment/locale/ko';
import { Actions } from '../components/Actions';

import BranchLocationPop from '../components/BranchLocationPop';
import CalendarPop from '../components/CalendarPop';
import ExperienceTypePop from '../components/ExperienceTypePop';

let _experienceTypeMap = {
  'FULL_TIME': '종일 09:00 ~ 24:00',
  'A_TYPE': '오전 09:00 ~ 13:00',
  'B_TYPE': '오후 13:00 ~ 17:00',
  'C_TYPE': '야간 17:00 ~ 21:00',
  'D_TYPE': '심야 21:00 ~ 24:00'
};

class ExperienceModify extends Component {
  constructor(props) {
    super(props);

    this.state = {
      type: '',
      branch_id: 0,
      branchName: '',
      isOpenLocationPop: false,
      isOpenCalendarPop: false,
      isOpenExperienceTypePop: false,
      testUsedate: '',
      experienceType: '',
      dateList: null,
      isValid: false,
      marketingObj: null
    }
  }

  componentDidMount() {
    var pathnames = this.props.location.pathname.split('/');
    this.setState({
      type: pathnames[pathnames.length - 1]
    });
  }

  _doCheckReserveNumber = () => {
    var code = this._input.value;

    if(!code) {
      Actions.alertOpen({msg: '예약번호를 입력해주세요.'}, [{type: 'ok', label: '확인'}]);
      return false;
    }

    Common.callApi('/studytoz/experienceCode/' + code, 'get', null)
    .then(result => {
      if(result.resultCode.toLowerCase() === 'success') {
        var _result = result.resultData;

        var _obj = {
          memberSex: _result.memberSex,
          testUsedate: _result.testUsedate,
          experienceType: _result.testUseType,
          memberName: _result.memberName,
          memberBirthday: _result.memberBirthday,
          memberPhone: _result.memberPhone,
          isWait: false,
          isParentReservation: _result.isParentReservation,
          studyType: _result.studyType,
          recogType: _result.recogType,
          marketing_experience_id: _result.marketing_experience_id
        };

        this.setState({
          testUsedate: _result.testUsedate,
          experienceType: _result.testUseType,
          marketingObj: _obj,
          isValid: true
        });

        this._getBranch(_result.branch_id);

      } else if(result.resultApiCode === 'E9101') {
        Actions.alertOpen({msg: '예약번호가 올바르지 않습니다.<br/>다시 확인하시고 입력해주세요.'}, [{type: 'ok', label: '확인'}]);
      }
    });
  }

  _doOpenRequestFormPop = (e) => {
    var type = e.target.dataset.type;

    if(type === 'location') {
      this.setState({ isOpenLocationPop: true });
    } else if(type === 'calendar') {
      var branch_id = this.state.marketingObj.branch_id;
      var memberSex = this.state.marketingObj.memberSex;
      this._getCalendars(branch_id, memberSex, false);
    } else if(type === 'experienceType') {
      this.setState({ isOpenExperienceTypePop: true });
    }

    document.body.style.overflowY = "hidden";
  }

  _doCloseRequestFormPop = (e) => {
    var type = e.target.dataset.type;
    var marketingObj = null;

    if(type === 'location') {
      this.setState({ isOpenLocationPop: false });
    } else if(type === 'calendar') {
      // 체험일자
      this.setState({ isOpenCalendarPop: false });
      var testUsedate = moment(new Date(e.target.dataset.testusedate)).format('YYYY-MM-DD');
      if(testUsedate === this.state.testUsedate) return;
      marketingObj = this.state.marketingObj;
      marketingObj.testUsedate = testUsedate;
      marketingObj.experienceType = '';
      this.setState({
        testUsedate: testUsedate,
        marketingObj: marketingObj,
        experienceType: ''
      });
    } else if(type === 'experienceType') {
      // 체험시간
      var experienceType = e.target.dataset.experiencetype;
      marketingObj = this.state.marketingObj;
      marketingObj.experienceType = experienceType;
      this.setState({ 
        isOpenExperienceTypePop: false,
        experienceType: experienceType,
        marketingObj: marketingObj
      });
    }

    document.body.style.overflowY = "auto";
  }

  _getBranch(onessaas_branch_id) {
    Common.callApi('/hp/onessaasbranch/' + onessaas_branch_id, 'get', null)
    .then(result => {
      if(result.resultCode === 'success') {
        var resultData = result.resultData;
        var marketingObj = this.state.marketingObj;
        var branch_id = resultData.id;
        marketingObj.branch_id = branch_id;
        this.setState({
          branch_id: branch_id,
          branchName: resultData.branchName,
          marketingObj: marketingObj
        });

        this._getCalendars(branch_id, this.state.memberSex, true);
      }
    });
  }

  _getCalendars = async (branch_id, memberSex, isInit) => {
    var startdate = moment().add(1, 'day').format('YYYY-MM-DD');
    var enddate = moment().add(14, 'day').format('YYYY-MM-DD');

    const result = await Common.callApi('/studytoz/calendar2/' + (memberSex === '남' ? 'male' : 'female') + '/' + branch_id + '/' + startdate + '/' + enddate, 'get', null);
    var dateList = [];
    if(result.resultCode === 'success') {
      var resultDataList = result.resultData;
      this.setState({ calendarList: resultDataList });
      for(var date in resultDataList) {
        var entity = resultDataList[date];
        var isAllow = false;
        for(var key in entity) {
          if(entity[key] === true) {
            isAllow = true;
            break;
          }
        }
        
        if(isAllow) dateList.push(date);
      }

      this.setState({ dateList: dateList });

      if(!isInit) {
        this.setState({ isOpenCalendarPop: true });
      }
    }
  }

  _doModifyExperience = () => {
    var _params = this.state.marketingObj;

    if(!_params.experienceType) {
      Actions.alertOpen({msg: '체험 시간을 선택해주세요.'}, [{type: 'ok', label: '확인'}]);
      return;
    }

    Common.callApi('/studytoz/freeExperienceReserve2', 'post', _params)
    .then(result => {
      if(result.resultCode.toLowerCase() === 'success') {
        gtag('event', '예약변경', {'event_category': '무료체험', 'event_label': '예약변경'});
        Actions.alertOpen({msg: '무료체험 변경 신청이 완료 되었습니다.<br/>토즈를 이용해 주셔서 감사합니다.'}, [{type: 'ok', label: '확인', callback: Actions.doMovePage, param: '/experience/' + this.state.type}]);
      } else if(result.resultApiCode === 'E9900') {
        Actions.alertOpen({msg: result.resultMessage}, [{type: 'ok', label: '확인'}]);
      }
    });
  }

  _doCancelExperience = () => {
    Common.callApi('/studytoz/freeExperienceCancel/' + this.state.marketingObj.marketing_experience_id, 'get', null)
    .then(result => {
      if(result.resultCode.toLowerCase() === 'success') {
        gtag('send', '예약취소', {'event_category': '무료체험', 'event_label': '예약취소'});
        Actions.alertOpen({msg: '무료체험 예약이 정상 취소되었습니다.<br/>다음에 다시 이용 해주세요.'}, [{type: 'ok', label: '확인', callback: Actions.doMovePage, param: '/experience/' + this.state.type}]);
      } else if(result.resultApiCode === 'E9900') {
        Actions.alertOpen({msg: result.resultMessage}, [{type: 'ok', label: '확인'}]);
      }
    });
  }

  _renderInput() {
    return (
      <div className="app-cont reser">
        <div className="reser-input">
          <p className="btxt">예약번호를 입력 해주세요</p>
          <p className="num-check">
            <input type="tel" maxLength="9" ref={ref => this._input = ref} />
            <a href={null} className="check-btn" onClick={this._doCheckReserveNumber}>확인</a>
          </p>
          <p className="stxt">
            ＊예약번호는 무료체험 신청 후 받으신 알림톡 또는<br/>
            SMS에 있습니다.
          </p>
        </div>
      </div>
    )
  }

  _renderInfoNotice() {
    if(this.state.type === 'modify') {
      return (
        <div className="reser-btxt">
          위 무료체험 신청내역으로<br/><strong>예약변경 하시겠습니까?</strong>
        </div>
      )
    } else if(this.state.type === 'cancel') {
      return (
        <div className="reser-btxt">
          위 무료체험 예약내역을<br/><strong>취소 하시겠습니까?</strong>
        </div>
      )
    }
  }

  _renderInfo() {
    return (
      <div className="app-cont reser">
        <div className="app-info">
          <p className="title">신청 정보</p>
          <ul className="list">
            <li className="loca">
              <p className="btxt">체험 센터</p>
              <p className="stxt fl">{this.state.branchName}</p>
              <a href={null} className="loca-btn fr layer-pop-open" data-type="location" onClick={this._doOpenRequestFormPop}>위치보기</a>
            </li>
            <li>
              <p className="btxt">체험 일자</p>
              <p className="pop-sel layer-pop-open" data-type="calendar" onClick={this.state.type === 'modify' ? this._doOpenRequestFormPop : null}>{this.state.testUsedate}</p>
            </li>
            <li>
              <p className="btxt">체험 시간</p>
              <p className="pop-sel layer-pop-open" data-type="experienceType" onClick={this.state.type === 'modify' ? this._doOpenRequestFormPop : null}>{this.state.experienceType ? _experienceTypeMap[this.state.experienceType] : '체험 시간 선택'}</p>
            </li>
          </ul>
        </div>

        <div className="note-text">
          <p className="tit">※유의 사항</p>
          <ul className="list">
            <li>예약 변경 완료 시 카카오 알림톡 또는 SMS 가 발송되며, 이전 예약 내역은 취소됩니다.</li>
          </ul>
        </div>

        {this._renderInfoNotice()}

        <div className="appinfo-fbtn reser">
          <a href={null} className="b-btn layer-pop-open" onClick={this.state.type === 'modify' ? this._doModifyExperience : this._doCancelExperience}>네</a>
        </div>
      </div> 
    )
  }

  render() {
    return (
      <div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">
            <div id="container-wrap"  className="div-cont" >
              <div id="contents">
                {!this.state.isValid ? this._renderInput() : ''}
                {this.state.isValid ? this._renderInfo() : ''}
              </div>
            </div>
          </div>
        </div>

        {!this.state.isOpenLocationPop ? '' : <BranchLocationPop branch_id={this.state.branch_id} onClick={this._doCloseRequestFormPop} />}
        {!this.state.isOpenCalendarPop ? '' : <CalendarPop testUsedate={this.state.testUsedate} dateList={this.state.dateList} onClick={this._doCloseRequestFormPop} />}
        {!this.state.isOpenExperienceTypePop ? '' : <ExperienceTypePop testUsedate={this.state.testUsedate} calendarList={this.state.calendarList} experienceType={this.state.experienceType} onClick={this._doCloseRequestFormPop} />}
      </div>  
    )
  }
}

export default ExperienceModify;